import useErrors from '../../error/useErrors';
import { useErrorStore } from '../../error';
import { serviceErrorSerializer } from './serviceErrors';

/*
 * This serve as a wrapper for useErrors hook to configure the result of useErrors hook.
 */
function useSubscribersErrors () {

    const store = useErrorStore();

    const {
        errors,
        hasError,
    } = useErrors({
        hook: 'useSubscribersErrors',
        input: null,
        serviceErrorSerializer,
        errorObservables: [
            store.observed.errors.getSubscribersData,
            store.observed.errors.getSubscribersReport,
        ],

    });

    /*
     * This response will be consumed by the UI components...
     */
    return {
        errors,
        hasError,
    };
}

export default useSubscribersErrors;
